import { useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";

interface Flags {
  hasAccessToNewBo: boolean;
  flagLoading: boolean;
}

export function useLDFlags({ shopId }: { shopId: string }): Flags {
  const [hasAccessToNewBo, setHasAccessToNewBo] = useState<boolean>(false);
  const [flagLoading, setFlagLoading] = useState<boolean>(true);

  const ldClient = useLDClient();
  async function idendifyLDFlagc(): Promise<
    (key: string, defaultValue: boolean) => boolean
  > {
    await ldClient?.identify({
      key: shopId, // Unique user identifier
      anonymous: false,
      custom: {
        shopId: shopId, // Shop selected by the user
      },
    });

    return function callFlags(flagKey: string, defaultValue: boolean) {
      return ldClient?.variation(flagKey, defaultValue);
    };
  }

  const getFeatureFlagValue = async (
    flagKey: string,
    defaultValue: boolean,
  ): Promise<boolean> => {
    const getFlagValueByShopId = await idendifyLDFlagc();
    return getFlagValueByShopId(flagKey, defaultValue);
  };

  useEffect(() => {
    getFeatureFlagValue("newBo", false).then((hasNewBoAccess) => {
      setHasAccessToNewBo(hasNewBoAccess);
      setFlagLoading(false);
    });
  }, [shopId, ldClient]);

  return { hasAccessToNewBo, flagLoading };
}
